import Vue from 'vue';
import Donation from './donation/donation.vue';
Vue.component('donation', Donation);
